<template>
  <div class="user-center__dynamic-edit-container user-center__common-child-container">
    <div class="dynamic-edit__wrapper center-common-form-wrapper">
      <!-- 顶部 -->
      <sub-page-header>
        <template #title>
          <router-link
            tag="div"
            :to="nav.url"
            active-class="active"
            class="title__front-item"
            v-for="(nav, index) in breadcrumbs"
            :key="index"
            >项目文件夹：{{names}} </router-link>

        </template>
        <template #hint>

        </template>
        <template #bt>
          <router-link class="el-button yellow" to="/my/exceldata">导出Excel材料清单</router-link>
        </template>
      </sub-page-header>
      <!-- form部分 -->
      <product-list
        class="product__main-body manage-list__main-body"
        theme="collect-list"
        :products="lists"
        :isShowPagination="paginationConfig"
        @onDelete="del"
        @addCarts="addCart"
      ></product-list>
    </div>
  </div>
</template>

<script>
import ProductList from '@/pages/product/_list.vue';
import { folderlist, delmaterialcollection, addmaterialexcel } from '@/api/user';
import { userDel } from '@/api/common';
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
    ProductList,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      lists: [],
      names: '',
      pageSize: 15,
      paginationConfig: null,
      loading: false,
      btCurrentIndex: -1,
      breadcrumbs: [
        {
          name: '项目文件夹',
          url: '/my/collects/products/0',
        },
      ],

    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    init() {
      this.getMyProducts();
    },
    async getMyProducts() {
      this.$store.commit('openLoading');
      const res = await folderlist({
        pid: this.$route.params.id,
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.paginationConfig = data.total;
      this.lists = data.list;
      this.names = data.project_name;
      this.$store.commit('closeLoading');
    },
    del(id) {
      const that = this;
      userDel('确定删除该项目？', () => delmaterialcollection({ id }), () => {
        this.getMyProducts();
      });
    },
    change(id) {
      console.log(id);
    },
    async addCart(id) {
      const message = '加入导出EXCEL项目清单成功！';
      const that = this;
      try {
        const result = await addmaterialexcel({
          id,
        });
        // console.log(result);
        if (result.success === true) {
          that.$message({
            type: 'success',
            message,
            duration: 1000,
            onClose() {
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      // const that = this;
      // userAddExcel('确定把该产品加入材料清单里？', () => addmaterialexcel({ id }), () => {
      // this.getMyProducts();
      /// });
    },
  },
};
</script>

<style>
  .products-container {
      width: 96%;
      margin-left: 2%;
  }
.el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    padding: 5px 8px;
    font-size: 12px;
    border-radius: 4px;

  }
  .red{
     background-color: #FF0000;
     color: #ffffff;
  }
  .black{
     background-color: #000;
     color: #ffffff;
     margin-left: 10px;
  }

  .yellow{
     background-color: #FABE00;
     color: #ffffff;
      margin-left: 10px;
  }
</style>
